import _ from 'lodash';
import * as types from '../constants/action-types';

const initialState = {
  services: {},
  isFetching: false,
  requestedServices: false
};

export default function services (state = initialState, action) {
  const { data, error } = action;

  switch (action.type) {
  case types.SERVICES_FETCH_REQUEST:
  case types.CONCIERGE_QUOTE_REQUEST:
  case types.CONCIERGE_CREATE_REQUEST:
    return _.merge({}, state, {
      isFetching: true
    });

  case types.SERVICES_FETCH_SUCCESS:
    return _.merge({}, state, {
      services: action.services,
      isFetching: false
    });

  case types.CONCIERGE_QUOTE_SUCCESS:
    return {
      ...state,
      quote: data,
      isFetching: false
    };

  case types.CONCIERGE_QUOTE_FAILURE:
  case types.CONCIERGE_CREATE_FAILURE:
    return {
      ...state,
      error
    };

  case types.CONCIERGE_CREATE_SUCCESS:
    return _.merge({}, state, {
      requestedServices: true,
      data: action.data,
      isFetching: false
    });

  default:
    return state;
  }
}
